import type { BaseProps } from '../../types'
import type { AlertProps } from './types'
import { InnerAlert } from './InnerAlert'

type Props = AlertProps & BaseProps<HTMLDivElement>

/**
 * The alert component can be used to provide users with information, such as success or error messages. The alert component can be used as toaster to highlight events without interrupting the user's task or as inline to supplement extra information to a specific component.
 *
 * Demos:
 * - [Alert](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/primitives-alert--docs)
 *
 */
export const Alert = (props: Props) => <InnerAlert {...props} />
